import * as React from "react"
import { Link } from "gatsby"
import {Container, Row, Col} from 'react-bootstrap';
// import PropTypes from "prop-types"

const ResourcesFilters = () => {
  return(
    <Container className="resources_filters">
        <Row>
          <Col className="filters d-flex align-items-center justify-content-md-center">
              <Link 
              to="/resources" 
              className={`btn btn-solid btn-loyall blue-hover`}
              activeStyle={{ backgroundColor: "#2669FF", color: "#fff", border: "0" }}
              >
                Alles zien
              </Link>
              <Link 
              to="/blogs" 
              className={`btn btn-solid btn-loyall blue-hover`}
              activeStyle={{ backgroundColor: "#2669FF", color: "#fff", border: "0" }}
              >
                Blogs
              </Link>
              <Link 
              to="/webinars" 
              className={`btn btn-solid btn-loyall blue-hover`}
              activeStyle={{ backgroundColor: "#2669FF", color: "#fff", border: "0" }}
              >
                Webinars
              </Link>
              <Link 
              to="/downloads" 
              className={`btn btn-solid btn-loyall blue-hover`}
              activeStyle={{ backgroundColor: "#2669FF", color: "#fff", border: "0" }}
              >
                Downloads
              </Link>
          </Col>
        </Row>
    </Container>
  )
}

export default ResourcesFilters